import { render, staticRenderFns } from "./ModalUploadDocumentos.vue?vue&type=template&id=8fbf8052&scoped=true"
import script from "./ModalUploadDocumentos.vue?vue&type=script&lang=js"
export * from "./ModalUploadDocumentos.vue?vue&type=script&lang=js"
import style0 from "./ModalUploadDocumentos.vue?vue&type=style&index=0&id=8fbf8052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbf8052",
  null
  
)

export default component.exports